<template>
  <div v-if="iframeCode" :class="{ container: isContained }" v-html="iframeCode"></div>
</template>

<script>
export default defineNuxtComponent({
  props: {
    iframeCode: {
      type: String,
      default: null,
    },
    isContained: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (!this.iframeCode?.includes('yotpo-widget-instance')) return;
    this.initYotpoWidgets();
  },
  methods: {
    async initYotpoWidgets(retries = 20) {
      await nextTick();
      const container = globalThis.yotpoWidgetsContainer;
      if (container?.initWidgets) {
        container.initWidgets();
        return;
      }
      if (retries > 0) setTimeout(() => this.initYotpoWidgets(retries - 1), 150);
    },
  },
});
</script>
